module.exports = __webpack_public_path__ + "img/1.164efa7e.gif";